import { render, staticRenderFns } from "./QuantityButtons.vue?vue&type=template&id=496522d9&"
import script from "./QuantityButtons.vue?vue&type=script&lang=js&"
export * from "./QuantityButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports